export default "__VITE_ASSET__9e5ef1b3__"